import invariant from 'invariant'
import {
  LIBRARY_ITEM_SET_ITEM_LIST,
  LIBRARY_ITEM_SET_CATEGORY_LIST,
  LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID,
  LIBRARY_ITEM_SET_CURRENT_ITEM_ID,
  LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID,
  LIBRARY_ITEM_SET_OUTLETS,
  LIBRARY_ITEM_SET_ITEM_SUMMARY,
  LIBRARY_ITEM_SET_FILTER_STATE,
  LIBRARY_ITEM_SET_TOTAL_PAGE,
  LIBRARY_ITEM_SET_CURRENT_PAGE,
  LIBRARY_ITEM_UNSET_FILTER_STATE,
  LIBRARY_ITEM_SET_TYPE_IMPORT,
  LIBRARY_ITEM_SHOW_SECTION_UPLOADER,
  LIBRARY_ITEM_OPEN_RIGHT_COLUMN,
  LIBRARY_ITEM_CLOSE_RIGHT_COLUMN,
  LIBRARY_ITEM_SET_ITEM_DETAIL,
  LIBRARY_ITEM_ON_DROP_IMAGE,
  LIBRARY_ITEM_ON_DELETE_IMAGE,
  LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_SHOW_COGS_MODAL,
  LIBRARY_ITEM_HIDE_COGS_MODAL,
  LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM,
  LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL,
  LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL,
  LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_ITEM_SET_MODIFIERS,
  LIBRARY_ITEM_HIDE_DELETE_MODAL,
  LIBRARY_ITEM_SHOW_DELETE_MODAL,
  LIBRARY_ITEM_SET_NEW_CATEGORY,
  LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL,
  LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL,
  LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID,
  LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES,
  LIBRARY_ITEM_SHOW_IMPORT_MODAL,
  LIBRARY_ITEM_HIDE_IMPORT_MODAL,
  LIBRARY_ITEM_SET_MUST_SCROLL_TOP,
  LIBRARY_ITEM_SET_IS_SUBMITTING_FORM,
  LIBRARY_ITEM_SET_TAXES
} from 'actions/library/item/constants'
import { isFSA } from 'flux-standard-action'

let initialState = {
  items: [],
  itemDetail: null,
  currentPage: null,
  totalPage: null,
  inventories: [
    {id: '0', name: 'All Inventory'},
    {id: '1', name: 'Low Stock Alert'},
    {id: '2', name: 'Out of Stock Alert'}
  ],
  currentInventoryId: 0,
  currentCategoryId: 0,
  search: '',
  outlets: [],
  categories: [],
  summary: {total_pages: 0, total_items: 0},
  filterState: {categoryId: 0, typeInventoryId: 0, keyword: ''},
  importType: 'modify',
  showSectionUploader: false,
  openRightColumn: false,
  showDeleteModal: false,
  files: null,
  tempFiles: {},
  gravatar: null,
  removeImage: false,
  showUploadValidationModal: false,
  textModal: '',
  deletedItem: null,
  showDeleteItemModal: false,
  showItemVariantModal: false,
  showItemInventoryAlertModal: false,
  showSaveToAllOutletsModal: false,
  showCOGSModal: false,
  mustScrollTop: false,
  previousItemForm: {
    name: null,
    category: null,
    itemVariant: [],
    itemInventory: [],
    itemModifier: [],
    description: null
  },
  modifiers: [],
  modifierIds: [],
  newCategory: null,
  showNewCategoryModal: false,
  previousCategoryId: null,
  previousCategories: [],
  showImportModal: false,
  isTrack: false,
  isSubmittingForm: false
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )
  const {payload = {}} = action
  switch (action.type) {
    case LIBRARY_ITEM_SET_MUST_SCROLL_TOP:
      return {...state, mustScrollTop: payload.mustScrollTop}
    case LIBRARY_ITEM_SET_ITEM_LIST:
      return {...state, items: payload.items}
    case LIBRARY_ITEM_SET_CATEGORY_LIST:
      return {...state, categories: payload.categories}
    case LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID:
      return {...state, currentCategoryId: payload.categoryId}
    case LIBRARY_ITEM_SET_CURRENT_ITEM_ID:
      return {...state, currentItemId: payload.currentItemId}
    case LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID:
      return {...state, currentInventoryId: payload.inventoryId}
    case LIBRARY_ITEM_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case LIBRARY_ITEM_SET_ITEM_SUMMARY:
      return {...state, summary: payload.itemSummary}
    case LIBRARY_ITEM_SET_FILTER_STATE:
      return {...state, filterState: {categoryId: payload.categoryId, typeInventoryId: payload.typeInventoryId, keyword: payload.keyword}}
    case LIBRARY_ITEM_UNSET_FILTER_STATE:
      return {...state, filterState: {categoryId: 0, typeInventoryId: 0, keyword: ''}}
    case LIBRARY_ITEM_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.totalPage}
    case LIBRARY_ITEM_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.currentPage}
    case LIBRARY_ITEM_SET_TYPE_IMPORT:
      return {...state, importType: payload.importType}
    case LIBRARY_ITEM_SHOW_SECTION_UPLOADER:
      return {...state, showSectionUploader: payload.showSectionUploader}
    case LIBRARY_ITEM_OPEN_RIGHT_COLUMN:
      return {...state, openRightColumn: true}
    case LIBRARY_ITEM_CLOSE_RIGHT_COLUMN:
      return {...state, openRightColumn: false}
    case LIBRARY_ITEM_SET_ITEM_DETAIL:
      return {...state, itemDetail: payload.item}
    case LIBRARY_ITEM_ON_DROP_IMAGE:
      return {...state, files: payload.fileStateacceptedFiles, removeImage: payload.fileStateremoveImage}
    case LIBRARY_ITEM_ON_DELETE_IMAGE:
      return {...state, files: payload.fileStateacceptedFiles, gravatar: payload.fileStategravatar, removeImage: payload.fileStateremoveImage}
    case LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL:
      return {...state, showItemVariantModal: true}
    case LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL:
      return {...state, showItemVariantModal: false}
    case LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL:
      return {...state, showSaveToAllOutletsModal: true}
    case LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL:
      return {...state, showSaveToAllOutletsModal: false}
    case LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL:
      return {...state, showItemInventoryAlertModal: true}
    case LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL:
      return {...state, showItemInventoryAlertModal: false}
    case LIBRARY_ITEM_SHOW_COGS_MODAL:
      return {...state, showCOGSModal: true, isTrack: payload.isTrack}
    case LIBRARY_ITEM_HIDE_COGS_MODAL:
      return {...state, showCOGSModal: false}
    case LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM:
      return {...state, previousItemForm: {...payload.previousItemForm}}
    case LIBRARY_ITEM_SET_MODIFIERS:
      return {...state, modifiers: payload.modifiers}
    case LIBRARY_ITEM_SET_TAXES:
      return {...state, taxes: payload.taxes}
    case LIBRARY_ITEM_SHOW_DELETE_MODAL:
      return {...state, showDeleteModal: true}
    case LIBRARY_ITEM_HIDE_DELETE_MODAL:
      return {...state, showDeleteModal: false}
    case LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL:
      return {...state, showNewCategoryModal: true}
    case LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL:
      return {...state, showNewCategoryModal: false}
    case LIBRARY_ITEM_SET_NEW_CATEGORY:
      return {...state, newCategory: payload.category}
    case LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES:
      return {...state, previousCategories: payload.categories}
    case LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID:
      return {...state, previousCategoryId: payload.categoryId}
    case LIBRARY_ITEM_SHOW_IMPORT_MODAL:
      return {...state, showImportModal: true}
    case LIBRARY_ITEM_HIDE_IMPORT_MODAL:
      return {...state, showImportModal: false}
    case LIBRARY_ITEM_SET_IS_SUBMITTING_FORM:
      return {...state, isSubmittingForm: payload.isSubmittingForm}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/library/item.js